module.exports = __webpack_public_path__ + "img/wenjian.e3744126.png";